/**
 * Created by tpetridis on 23/2/2017.
 */
/* eslint no-console: "off", quotes: "off" */

import Vue from 'vue';

export default {
  setupCommonModal (
    {
      showImmediate = false,
      hideImmediate = false,
      hideManually = false,
      afterHideCallback
    } = {}
  ) {
    const {showCommonModal, hideCommonModal} = this;

    Vue.nextTick(() => {
      showCommonModal({immediate: showImmediate});

      if (!hideManually) {
        $('.modal-overlay, .close-btn, .close_modal').click(event => {
          if (!$(event.target).hasClass('no_close')) {
            hideCommonModal({immediate: hideImmediate, afterHideCallback});
          }
        });

        // allow user to interact with content inside the modal
        $('.modal-content').click(event => {
          event.stopPropagation();
        });
      }
    })
  },
  showCommonModal ({immediate = false} = {}) {
    $('body').addClass('no-scroll');

    if (immediate) {
      $('.modal-overlay').addClass('show');
    } else {
      $('.modal-overlay').fadeIn().addClass('show');
    }

    // necessary to remove the 'display' style that was added automatically before from 'fadeOut' (ref. 'hideCommonModal' method)
    $('.modal-content').fadeIn(0);
  },
  hideCommonModal ({immediate = false, afterHideCallback} = {}) {
    $('body').removeClass('no-scroll');
    $('.modal-overlay').removeClass('show');

    const modalContentElement = $('.modal-content')
    if (modalContentElement && modalContentElement.length > 0) {
      const fadeOutDuration = immediate ? 0 : undefined
      modalContentElement.fadeOut(fadeOutDuration, afterHideCallback)
    } else if (afterHideCallback) {
      afterHideCallback()
    }
  },
  // User object will let us check authentication status
  showHideModalForHomePage(vm) {
    this.setupCommonModal({
      afterHideCallback: () => {
        vm.storeModalForSettings(null);

        if (vm.$store.state.common.userDetails.subscribed && vm.$root._route.fullPath === '/home/settings') {
          vm.$router.push('/home');
        }
      }
    });
  },
  showHideModal(vm) {
    this.setupCommonModal({
      afterHideCallback: () => {
        vm.storeModalForHomePage(null);
      }
    });
  },
  hideGenericModal() {
    /* eslint-disable */
    // hide modal
    $(".popup_box").fadeOut(200);
    $(".overlay").fadeOut(200);
    $('.modal, .modal-overlay').fadeOut();
    $("body").removeClass("modal-open");
    console.log('ShowHideModal Generic Hide For hideModal/modal');
    /* eslint-enable */
  },
  hideModal(vm) {
    /* eslint-disable */
    // hide modal
    $(".popup_box").fadeOut(200);
    $(".overlay").fadeOut(200);
    $('.modal, .modal-overlay').fadeOut();
    $("body").removeClass("modal-open");
    console.log('ShowHideModal Generic Hide For hideModal/modal');
    vm.storeModalForSettings(null);
    /* eslint-enable */
  },
  showHideModalForHomeStorePage(vm) {
    this.setupCommonModal({
      afterHideCallback: () => {
        vm.storeModalForHomePage(null);
        vm.storeModalForStore(null);
      }
    });
  },
  hideModalForHomeStorePage(vm) {
    /* eslint-disable */
    // hide modal
    $("body").removeClass("modal-open");
    $(".popup_box").fadeOut(200);
    $(".overlay").fadeOut(200);
    $('.modal, .modal-overlay').fadeOut();
    console.log("----------------------- Correct Exit ResubscribeGame hideModal");
    vm.storeModalForHomePage(null);
    vm.storeModalForStore(null);
    /* eslint-enable */
  },
  showHideModalForGameNotificationPage(vm) {
    /* eslint-disable */
    vm.$nextTick(() => {
      // open modal
      $('.modal,.modal-overlay').fadeIn(200);
      // hide modal
      $('.modal-close, .modal-overlay').click(() => {
        console.log('showHideModalForGameNotificationPage');
        if (vm.playersDetails) { // Notifications Case
          console.log('showHideModalForGameNotificationPage close Modal' + vm.showedModal);
          vm.storeModalForHomePage(null);
          vm.showedModal = true;
          vm.getUserLoginDetails().then(() => {
            vm.$router.push('home');
          });
        }
      });
    });
  },
  showHideModalForFailedPrizeAwarding(vm) {
    /* eslint-disable */
    vm.$nextTick(() => {
      // open modal
      $('.modal,.modal-overlay').fadeIn(200);
      // hide modal
      $('.modal-close, .modal-overlay').click(() => {
        console.log('showHideModalForFailedPrizeAwarding');
        vm.storeModalForHomePage(null);
        vm.resetPrizeData();
        vm.resetGameState();
        vm.$router.push('home');
      });
    });
  },
  showHideModalForFreeGame(vm) {
    vm.$nextTick(() => {
      // open modal
      $('.modal,.modal-overlay').fadeIn(200);
      // hide modal
      $('.modal-close, .modal-overlay').click(() => {
        console.log('showHideModalForFreeGame');
        this.resetAllUserInfo(vm);
        vm.$router.push('/');
      });
    });
    /* eslint-enable */
  },
  resetAllUserInfo(vm) {
    vm.storeModalForHomePage(null);
    vm.resetPrizeData();
    vm.resetGameState();
    vm.resetUnauthorizedMsisdn();
    vm.resetCode();
    vm.validTransitionForFreeGameMethod(false);
  },
};



// WEBPACK FOOTER //
// ./src/common/modals.js